import * as React from 'react';

import cn from 'classnames';

import { Translate } from '@decorators';

import { FormRow, SimpleCheckBox } from '@common/components/ui';

import { IDmcaConfirmations } from '@interfaces';

import { IDmcaConfirmationsProps } from './types';

import * as s from './DmcaConfirmations.scss';

@Translate('common.containers.Dmca.components.DmcaConfirmations')
export class DmcaConfirmations extends React.Component<IDmcaConfirmationsProps> {

	onToggle = (name: keyof IDmcaConfirmations) => (isChecked: boolean) => {
		const { onChange } = this.props;

		onChange({ [name]: isChecked });
	};

	render() {
		const {
			isOwnershipConfirmed,
			isCopyrightInfringementConfirmed,
			isValidityOfClaimsConfirmed,
			isCommunicationByEmailConfirmed,
			isPersonalDataUseConfirmed,
			errorFields,
		} = this.props;

		return (
			<div className={s.block}>
				<FormRow className={cn(s.formRow, {
					[s.error]: errorFields.includes('isOwnershipConfirmed'),
				})}>
					<SimpleCheckBox
						label={this.t('isOwnershipConfirmed')}
						checked={isOwnershipConfirmed}
						onToggle={this.onToggle('isOwnershipConfirmed')}
					/>
				</FormRow>

				<FormRow className={cn(s.formRow, {
					[s.error]: errorFields.includes('isCopyrightInfringementConfirmed'),
				})}>
					<SimpleCheckBox
						label={this.t('isCopyrightInfringementConfirmed')}
						checked={isCopyrightInfringementConfirmed}
						onToggle={this.onToggle('isCopyrightInfringementConfirmed')}
					/>
				</FormRow>

				<FormRow className={cn(s.formRow, {
					[s.error]: errorFields.includes('isValidityOfClaimsConfirmed'),
				})}>
					<SimpleCheckBox
						label={this.t('isValidityOfClaimsConfirmed')}
						checked={isValidityOfClaimsConfirmed}
						onToggle={this.onToggle('isValidityOfClaimsConfirmed')}
					/>
				</FormRow>

				<FormRow className={cn(s.formRow, {
					[s.error]: errorFields.includes('isCommunicationByEmailConfirmed'),
				})}>
					<SimpleCheckBox
						label={this.t('isCommunicationByEmailConfirmed')}
						checked={isCommunicationByEmailConfirmed}
						onToggle={this.onToggle('isCommunicationByEmailConfirmed')}
					/>
				</FormRow>

				<FormRow className={cn(s.formRow, {
					[s.error]: errorFields.includes('isPersonalDataUseConfirmed'),
				})}>
					<SimpleCheckBox
						label={this.t('isPersonalDataUseConfirmed')}
						checked={isPersonalDataUseConfirmed}
						onToggle={this.onToggle('isPersonalDataUseConfirmed')}
					/>
				</FormRow>
			</div>
		);
	}

}
